'use client'

import { Modal, type ModalProps } from '@mantine/core'
import themeModalClasses from '@lib/theme-modal.module.css'
import { APP_MODAL_OVERLAY_PROPS, APP_MODAL_SIZE, APP_MODAL_TRANSITION_PROPS } from '@lib/modal-config'

export { APP_MODAL_OVERLAY_PROPS, APP_MODAL_SIZE, APP_MODAL_TRANSITION_PROPS }

type AppModalProps = ModalProps

export default function AppModal({
    centered = true,
    radius = 'xl',
    size = APP_MODAL_SIZE,
    padding = 'xl',
    transitionProps,
    overlayProps,
    classNames,
    ...props
}: AppModalProps) {
    return (
        <Modal
            centered={centered}
            radius={radius}
            size={size}
            padding={padding}
            transitionProps={{ ...APP_MODAL_TRANSITION_PROPS, ...transitionProps }}
            overlayProps={{ ...APP_MODAL_OVERLAY_PROPS, ...overlayProps }}
            classNames={{
                ...themeModalClasses,
                ...classNames
            }}
            {...props}
        />
    )
}
